/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {publishGpsEvent} from '../api'

export const useMutationPublishGpsEvent = createReactQueryMutationHook('publishGpsEvent', publishGpsEvent)
